import { Button } from "@shopify/polaris";
import { EditMajorMonotone } from "@shopify/polaris-icons";
import React, { useCallback, useRef } from "react";
import styled from "styled-components";

import { useMutation } from "@apollo/react-hooks";
import { MARK_AMAZON_IDEA_BADGE } from "../../../graphql/mutations/amazon-idea";
import { arrInvalid, handleError, reducerFn } from "../../../helper";
import useTimeout from "../../../hooks/useTimeout";
import { useToastContext } from "../../shared/ToastContext";

export default function AmazonIdeaMarkBadge({ ids, node, handleCompleted }) {
    const [state, setState] = React.useReducer(reducerFn, {
        color: node?.hexColor ? node.hexColor : "#f5f5f5",
        show: handleCompleted ? true : !!node?.hexColor,
    });

    React.useEffect(() => {
        if (node?.hexColor) {
            setState({ color: node.hexColor });
        }
    }, [node?.hexColor]);

    const { setNotify, toggleToast } = useToastContext();

    const [markBadge] = useMutation(MARK_AMAZON_IDEA_BADGE, {
        onCompleted: () => {
            setNotify({ msg: "Update Amazon Idea Badge success", err: false });

            handleCompleted && handleCompleted();
        },
        onError: (err) => {
            setNotify({ msg: handleError(err?.toString()), err: true });
        },
    });

    const [setDelay] = useTimeout();
    const handleChange = useCallback(
        (value) => {
            if (!value.target);

            setState({ color: value.target.value });

            const target = value.target;
            if (arrInvalid(ids)) return;

            setDelay(() => {
                setNotify && setNotify({ msg: null, err: false });
                toggleToast && toggleToast(true);

                markBadge({
                    variables: {
                        ids,
                        hexColor: target.value,
                    },
                });
            });
        },
        [markBadge, setNotify, toggleToast, ids],
    );

    const inputRef = useRef(null);

    return (
        <Wrapper title="Mark Badge">
            {state.show ? (
                <input
                    ref={inputRef}
                    type="color"
                    value={state.color}
                    onChange={handleChange}
                />
            ) : (
                <Button
                    plain
                    size="slim"
                    icon={EditMajorMonotone}
                    onClick={() => {
                        setState({ show: true });
                    }}
                />
            )}
        </Wrapper>
    );
}

const Wrapper = styled.div`
    input[type="color"] {
        -webkit-appearance: none;
        border: none;
        width: 70px;
        height: 24px;
        display: inline-flex;
        align-items: center;
        padding: 0;
        border: 0.2rem solid var(--p-surface, white);
        border-radius: 2rem;
        cursor: pointer;
    }

    input[type="color"]::-webkit-color-swatch-wrapper {
        padding: 0;
    }
    input[type="color"]::-webkit-color-swatch {
        border: none;
    }
`;
